<div>
  <ion-card color="warning">
    <ion-fab vertical="top" horizontal="end">
      <ion-fab-button color="danger" size="small">
        <ion-icon name="alert-sharp"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-card-header>
      <ion-card-title>{{ 'PUZZLE.no_local_storage_warning.title'|translate }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      {{ 'PUZZLE.no_local_storage_warning.text'|translate }}
      <a href="{{ url }}" target="_blank">{{ url }}</a>
    </ion-card-content>
  </ion-card>
</div>
